import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import {
  transformGetCulturesResponse,
  transformGetPhenologicalStagesResponse,
  transformGetDates,
} from 'helper/Meteorology/Agro/CultureIndex';
import { CultureIndexCulture } from 'types/Meteorology/Agro/CultureIndex/culture';
import { CultureIndexPhenologicalStage } from 'types/Meteorology/Agro/CultureIndex/phenologicalStage';
import { CultureIndexForecastPeriodParams } from 'types/Meteorology/Agro/CultureIndex/forecastPeriod';

export const cultureIndexApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCultureIndexCultures: build.query<CultureIndexCulture[], void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/indice-desenvolvimento-cultura/listar-culturas/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetCulturesResponse,
    }),
    getCultureIndexForecastDates: build.query<string[], void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/indice-desenvolvimento-cultura/listar-datas-previsao/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetDates,
    }),
    getCultureIndexForecastPeriod: build.query<string[], CultureIndexForecastPeriodParams>({
      query: ({ forecastDate }) => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/indice-desenvolvimento-cultura/listar-periodo-previsao/?product_key=${productKey}`,
          method: 'POST',
          body: {
            data_previsao: forecastDate,
          },
        };
      },
      transformResponse: transformGetDates,
    }),
    getCultureIndexPhenologicalStages: build.query<CultureIndexPhenologicalStage[], string>({
      query: (cultura) => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/indice-desenvolvimento-cultura/listar-estagios-fenologicos/?product_key=${productKey}`,
          method: 'POST',
          body: {
            cultura,
          },
        };
      },
      transformResponse: transformGetPhenologicalStagesResponse,
    }),
  }),
});

export const {
  useGetCultureIndexCulturesQuery,
  useGetCultureIndexPhenologicalStagesQuery,
  useGetCultureIndexForecastDatesQuery,
  useGetCultureIndexForecastPeriodQuery,
  useLazyGetCultureIndexForecastPeriodQuery,
} = cultureIndexApi;
